import { SearchParams } from '@/api/endpoints';

export function generateUrlParams<P extends SearchParams>(searchParams: P): string {
  const prefix = Object.keys(searchParams)?.length ? '?' : '';
  const stringifiedParams = Object.keys(searchParams).map(key => `${key}=${searchParams[key]}`);
  return prefix + stringifiedParams.join('&');
}
